const BreakPoints = {
    default: 3,
    700: 2,
    500: 1
};

export default BreakPoints;